<template>
  <div class="favorite-container">
    <!-- 顶部横幅 -->
    <TopHeader />

    <!-- 收藏列表 -->
    <div class="main-wrapper">
      <div class="back-link" @click="goBack">
        <img src="@/assets/image/back.png" class="back-icon" />
        <span>返回首页</span>
      </div>
      <div class="page-title">我的收藏</div>
      
      <div v-if="loading" class="loading-box">加载中...</div>
      
      <div v-else-if="favorites.length === 0" class="empty-box">
        <img src="@/assets/image/star.png" class="empty-icon" />
        <p>暂无收藏的题目</p>
      </div>

      <div v-else class="favorite-list">
        <div 
          v-for="(item, index) in favorites" 
          :key="item.favoriteId" 
          class="favorite-item"
        >
          <div class="item-header">
            <span :class="['item-type', item.type === 'single' ? 'single' : 'multi']">
              {{ item.type === 'single' ? '单选题' : '多选题' }}
            </span>
            <div class="item-action" @click="cancelFavorite(item, index)">
              <img src="@/assets/image/star-select.png" class="star-icon" />
              <span>取消收藏</span>
            </div>
          </div>
          <div class="item-title">{{ (pageNum - 1) * pageSize + index + 1 }}.{{ item.title }}</div>
          <div class="item-meta">
            <span class="meta-item">
              <img src="@/assets/image/time.png" class="meta-icon" />
              <span>收藏时间：{{ formatTime(item.collectTime) }}</span>
            </span>
            <span class="meta-item" v-if="item.sectionName">
              <img src="@/assets/image/kaoshi.png" class="meta-icon" />
              <span>{{ item.sectionName }}</span>
            </span>
          </div>
          <div class="item-footer">
            <button class="detail-btn" @click="viewDetail(item)">查看详情</button>
          </div>
        </div>
        
        <!-- 分页 -->
        <div v-if="total > pageSize" class="pagination">
          <button class="page-btn" :disabled="pageNum <= 1" @click="changePage(pageNum - 1)">上一页</button>
          <span class="page-info">{{ pageNum }} / {{ totalPages }}</span>
          <button class="page-btn" :disabled="pageNum >= totalPages" @click="changePage(pageNum + 1)">下一页</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TopHeader from '@/components/TopHeader.vue'
import { getFavoriteList, toggleFavorite as toggleFavoriteApi } from '@/api/question'
import { encodeId } from '@/utils/idEncoder'

export default {
  name: 'FavoritePage',
  components: {
    TopHeader
  },
  data() {
    return {
      loading: true,
      favorites: [],
      pageNum: 1,
      pageSize: 10,
      total: 0
    }
  },
  computed: {
    totalPages() {
      return Math.ceil(this.total / this.pageSize)
    }
  },
  created() {
    this.loadFavorites()
  },
  methods: {
    async loadFavorites() {
      this.loading = true
      try {
        const res = await getFavoriteList(this.pageNum, this.pageSize)
        this.favorites = res.data.list || []
        this.total = res.data.total || 0
      } catch (error) {
        console.error('加载收藏列表失败', error)
      } finally {
        this.loading = false
      }
    },
    changePage(page) {
      this.pageNum = page
      this.loadFavorites()
      window.scrollTo(0, 0)
    },
    async cancelFavorite(item) {
      try {
        await toggleFavoriteApi(item.questionId)
        // 重新加载当前页
        this.loadFavorites()
      } catch (error) {
        console.error('取消收藏失败', error)
      }
    },
    viewDetail(item) {
      // 跳转到题目详情，传递questionId
      this.$router.push('/favorite-detail/' + encodeId(item.questionId))
    },
    formatTime(time) {
      if (!time) return ''
      const d = new Date(time)
      const year = d.getFullYear()
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      const hour = String(d.getHours()).padStart(2, '0')
      const minute = String(d.getMinutes()).padStart(2, '0')
      return `${year}-${month}-${day} ${hour}:${minute}`
    },
    goBack() {
      this.$router.push('/home')
    }
  }
}
</script>

<style scoped>
.favorite-container {
  min-height: 100vh;
  background: #f5f5f5;
  padding-bottom: 40px;
  padding-top: 70px;
}

.main-wrapper {
  max-width: 900px;
  margin: 30px auto;
  padding: 0 20px;
}

.page-title {
  font-size: 20px;
  font-weight: 500;
  color: #333;
  margin-bottom: 20px;
}

.back-link {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 15px;
  font-size: 14px;
  color: #3d8c40;
  cursor: pointer;
}

.back-icon {
  width: 16px;
  height: 16px;
}

.back-link:hover {
  text-decoration: underline;
}

.loading-box, .empty-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 300px;
  background: #fff;
  border-radius: 8px;
  color: #999;
}

.empty-icon {
  width: 60px;
  height: 60px;
  opacity: 0.5;
  margin-bottom: 15px;
}

.empty-box p {
  font-size: 14px;
}

.favorite-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.favorite-item {
  background: #fff;
  border-radius: 8px;
  padding: 25px;
}

.item-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.item-type {
  font-size: 14px;
  font-weight: 500;
}

.item-type.single {
  color: #3d8c40;
}

.item-type.multi {
  color: #e74c3c;
}

.item-action {
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  font-size: 13px;
  color: #666;
}

.item-action .star-icon {
  width: 16px;
  height: 16px;
}

.item-action:hover {
  color: #e74c3c;
}

.item-title {
  font-size: 15px;
  color: #333;
  line-height: 1.6;
  margin-bottom: 15px;
}

.item-meta {
  display: flex;
  gap: 30px;
  margin-bottom: 20px;
}

.meta-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #999;
}

.meta-icon {
  width: 16px;
  height: 16px;
}

.item-footer {
  display: flex;
  justify-content: flex-end;
}

.detail-btn {
  padding: 10px 30px;
  background: #3d8c40;
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.2s;
}

.detail-btn:hover {
  background: #2e7d32;
}

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  margin-top: 30px;
  padding: 20px 0;
}

.page-btn {
  padding: 10px 25px;
  background: #fff;
  color: #3d8c40;
  border: 1px solid #3d8c40;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
}

.page-btn:hover:not(:disabled) {
  background: #3d8c40;
  color: #fff;
}

.page-btn:disabled {
  background: #f5f5f5;
  color: #ccc;
  border-color: #ddd;
  cursor: not-allowed;
}

.page-info {
  font-size: 14px;
  color: #666;
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
  .main-wrapper {
    margin: 20px auto;
    padding: 0 15px;
  }

  .page-title {
    font-size: 18px;
  }

  .favorite-item {
    padding: 20px 15px;
  }

  .item-meta {
    flex-direction: column;
    gap: 10px;
  }

  .detail-btn {
    width: 100%;
    padding: 12px;
  }
}
</style>
